var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',[_vm._v("권한 없음 관리자 문의 "),_c('br'),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.gotologin()}}},[_vm._v("로그인")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }